import * as React from 'react';
import type { SVGProps } from 'react';

const SvgNv = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" {...props}>
    <path d="M361.73 80.027h520.76c52.641 0 61.32 15.133 61.32 64.375v755.41c0 31.879-3.746 31.879-30.84 44.012l-29.586 13.215c-19.773 8.828-17.492 20.773-10.895 43.398l25 85.492c8.691 29.652-18.055 42.492-33.453 27.359l-580.31-571.81c-27.906-27.574-28.48-36.895-26.387-73.613l17.559-313.75c3-53.336 11.055-74.094 86.828-74.094z" />
  </svg>
);
export default SvgNv;
